module.exports = __webpack_public_path__ + "static/media/bad-thumb.a9b370b0.png";